import React, { useEffect, useRef, useState } from "react";
import { LayoutHome } from "../LayoutHome"
import { Button, Card, Table, Space, notification, Input } from "antd";
import {
  NumberInput,
  Text,
  Checkbox,
  Tag,
  Image,
  ButtonGroup,
  Modal,
  Panel,
} from "rsuite";
import { FaPencilAlt, FaPlus, FaSave, FaSign } from "react-icons/fa";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Check,
  DoorClosed,
  Eraser,
  LucideAArrowDown,
  PlusCircleIcon,
  RefreshCcw,
  Save,
} from "lucide-react";
import Highlighter from "react-highlight-words";
import SignatureCanvas from "react-signature-canvas";
import { getListaMedicos, saveMedico } from "../Services/CatalogosServices";

export const Medicos = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [idMedico, setIdMedico] = useState(0);
  const [nombre, setNombre] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [telefono, setTelefono] = useState("");
  const [correo, setCorreo] = useState("");
  const [msjErrMail, setErrMail] = useState("");
  const [esNefro, setEsNefro] = useState(0);
  const [activo, setActivo] = useState(1);
  const [foto, setFoto] = useState("");
  const [editarFoto, setEditarFoto] = useState(false);
  const [file, setFile] = useState([]);
  const [data, setData] = useState([]);
  const [openModalFirma, setOpenModalFirma] = useState(false);
  const [dataFirma, setDataFirma] = useState("");
  const [imageFirmaEnf, setImageFirmaEnf] = useState("/Images/SinFirma.jpg");
  const [dataFirmaEnf, setDataFirmaEnf] = useState("");

  const [api, contextHolder] = notification.useNotification();

  const initialized = useRef(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleCloseModalFirma = () => {
    setOpenModalFirma(false);
  };

  const signCanvas = useRef({});

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const clear = () => signCanvas.current.clear();

  const saveSignature = () => {
    if (signCanvas.current) {
      const data = signCanvas.current.toDataURL("image/png");
      setImageFirmaEnf(data);
      setDataFirmaEnf(data);
      setOpenModalFirma(false);
    }
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Nombre(s)",
      dataIndex: "nombre",
      width: "20%",
      key: "nombre",
      sorter: (a, b) => a.nombre.length - b.nombre.length,
      ...getColumnSearchProps("nombre"),
    },
    {
      title: "Apellidos",
      dataIndex: "apellidos",
      width: "20%",
      key: "apellidos",
      sorter: (a, b) => a.apellidos.length - b.apellidos.length,
      ...getColumnSearchProps("apellidos"),
    },
    {
      title: "Foto",
      dataIndex: "foto",
      width: "10%",
      key: "foto",
      align: "center",
      render: (text, record) => (
        <Image
          circle
          src={`Unidades/${idNegocio}/Medicos/${record.idMedico}/${record.foto}`}
          alt="Foto"
          width={60}
          height={60}
        />
      ),
    },
    {
      title: "Firma",
      dataIndex: "firma",
      width: "10%",
      key: "firma",
      align: "center",
      render: (text, record) => (
        <Image
          circle
          src={
            record.firma !== "SinFirma.jpg"
              ? `Unidades/${idNegocio}/Medicos/${record.idMedico}/${record.firma}`
              : `Images/${record.firma}`
          }
          alt="Firma"
          width={60}
          height={60}
        />
      ),
    },
    {
      title: "Es Nefro",
      dataIndex: "esNefro",
      width: "5%",
      key: "esNefro",
      align: "center",
      render: (text) =>
        text === 1 ? <Tag color="blue">Si</Tag> : <Tag color="#000">No</Tag>,
    },
    {
      title: "Teléfono",
      dataIndex: "telefono",
      width: "10%",
      key: "telefono",
      align: "center",
    },
    {
      title: "Correo",
      dataIndex: "correo",
      width: "30%",
      key: "correo",
    },
    {
      title: "Estatus",
      dataIndex: "activo",
      width: "5%",
      key: "activo",
      align: "center",
      render: (text) =>
        text === 1 ? (
          <Tag color="green">Activo</Tag>
        ) : (
          <Tag color="red">Inactivo</Tag>
        ),
    },
    {
      title: "Acción",
      dataIndex: "x",
      width: "5%",
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          icon={<EditOutlined />}
          color="primary"
          variant="outlined"
          onClick={() =>
            edit({
              idMedico: record.idMedico,
              nombre: record.nombre,
              apellidos: record.apellidos,
              telefono: record.telefono,
              correo: record.correo,
              foto: record.foto,
              firma: record.firma,
              esNefro: record.esNefro,
              activo: record.activo,
            })
          }
        ></Button>
      ),
    },
  ];

  const edit = (props) => {
    setEditarFoto(true);
    setIdMedico(props.idMedico);
    setNombre(props.nombre);
    setApellidos(props.apellidos);
    setTelefono(props.telefono);
    setCorreo(props.correo);
    setFoto(props.foto);
    var _path = `Unidades/${idNegocio}/Medicos/${props.idMedico}/${props.firma}`;
    if(props.firma === 'SinFirma.jpg'){
      _path = `Images/${props.firma}`;
    }
    setImageFirmaEnf(_path);
    setEsNefro(props.esNefro);
    setActivo(props.activo);
  };

  const validateEmail = (email) => {
    setCorreo(email);
    if (!email) {
      setErrMail("");
      return;
    }
    // A common regex pattern for email format validation
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(email)) {
      setErrMail("*Formato incorrecto*");
    } else {
      setErrMail("");
    }
  };

  const handleFile = (e) => {
    setFile(e.target.files);
  };

  const checkEsNefro = (e) => {
    if (e.target.checked) {
      setEsNefro(1);
    } else {
      setEsNefro(0);
    }
  };

  const checkActivo = (e) => {
    if (e.target.checked) {
      setActivo(1);
    } else {
      setActivo(0);
    }
  };

  const loadMedicos = async () => {
    await getListaMedicos(idNegocio)
      .then((res) => {
        setData(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const save = async () => {
    if (nombre.length === 0) {
      errorNotificaction("Nombre", "El nombre no puede estar vacio...");
      return;
    }
    if (apellidos.length === 0) {
      errorNotificaction(
        "Apellidos",
        "Los apellidos no pueden estar vacios...",
      );
      return;
    }
    if (msjErrMail !== "") {
      errorNotificaction("Correo", "El formato de correo es inválido...");
      return;
    }

    const formData = new FormData();
    formData.append("IdConsultorio", idNegocio);
    formData.append("IdMedico", idMedico);
    formData.append("Nombre", nombre);
    formData.append("Apellidos", apellidos);
    formData.append("NumCelular", telefono);
    formData.append("Correo", correo);
    formData.append("EsNefro", esNefro);
    formData.append("Foto", foto);
    formData.append("firma", imageFirmaEnf);
    formData.append("Estatus", activo);
    formData.append(
      "file",
      file !== null || file !== undefined ? file[0] : null,
    );

    await saveMedico(formData).then(async (res) => {
      if (res > 0) {
        successNotification(
          "Registro",
          "Se ha registrado la información de forma correcta.",
        );
        setTimeout(() => {
          setIdMedico(0);
          window.location.reload();
        }, 1000);
        setIdMedico(0);
      } else {
        errorNotificaction("No se ha registrado la información...", "Error");
      }
    });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadMedicos();
    }
  }, []);

  return (
    <>
      <title>Médicos - NefroSys</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Inicio
              </a>
            ),
          },
          { title: "Médicos" },
        ]}
        selectedKey={"1.1"}
      >
        {contextHolder}
        <Card title="Datos del perfil - Médico">
          <div className="row mb-2">
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>Nombre</Text>
              <Input
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>Apellidos</Text>
              <Input
                value={apellidos}
                onChange={(e) => setApellidos(e.target.value)}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>Teléfono</Text>
              <NumberInput
                controls={false}
                value={telefono}
                maxLength={10}
                onChange={(e) => setTelefono(e)}
              />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">
              <Text>Correo</Text>
              <Input
                value={correo}
                onChange={(e) => validateEmail(e.target.value)}
              />
              <Text size={"xs"} color={"red"} style={{ paddingTop: "5px" }}>
                {msjErrMail}
              </Text>
            </div>
            <div className="text-center col-lg-2 col-md-2 col-sm-2">
              <Text>Es Nefro</Text>
              <Checkbox
                onClick={(e) => checkEsNefro(e)}
                checked={esNefro === 1 ? true : false}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-4">
              {!editarFoto ? (
                <>
                  <Text>Cargar foto...</Text>
                  <input type="file" onChange={(e) => handleFile(e)} />
                </>
              ) : (
                <>
                  <Text>Foto actúal</Text>
                  <Image
                    circle
                    src={`Unidades/${idNegocio}/Medicos/${idMedico}/${foto}`}
                    alt="Médico"
                    width={80}
                    height={80}
                  />
                  &nbsp;{" "}
                  <Button
                    variant="link"
                    color="primary"
                    onClick={() => setEditarFoto(false)}
                  >
                    <FaPencilAlt></FaPencilAlt>
                  </Button>
                </>
              )}
            </div>
            <div className="text-center col-lg-2 col-md-2 col-sm-2">
              <Text>Activo</Text>
              <Checkbox
                onClick={(e) => checkActivo(e)}
                checked={activo === 1 ? true : false}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>Firma</Text>
              <Image
                rounded
                src={imageFirmaEnf}
                alt="Firma"
                style={{ border: "solid 0.1em", borderColor: "#D1D1D1" }}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <br></br>
              <Button
                type="primary"
                icon={<FaSign></FaSign>}
                onClick={() => setOpenModalFirma(true)}
              >
                Cargar firma...
              </Button>
            </div>
            <div className="text-end col-lg-2 col-md-2 col-sm-2">
              <br></br>
              <ButtonGroup vertical divided>
                <Button
                  icon={<FaPlus></FaPlus>}
                  onClick={() => window.location.reload()}
                  color="primary"
                  variant="outlined"
                  style={{ width: "110px" }}
                >
                  Nuevo
                </Button>
                &nbsp;
                <Button
                  icon={<FaSave></FaSave>}
                  onClick={save}
                  type="primary"
                  style={{ width: "110px" }}
                >
                  Guardar
                </Button>
              </ButtonGroup>
            </div>
          </div>
        </Card>
        <br></br>
        <Card title="Lista de Personal de Médicos">
          <div className="row">
            <div className="col">
              <Table
                bordered
                size="small"
                rowKey={(record) => record.idMedico}
                columns={columns}
                dataSource={data}
                pagination={{ pageSize: 5 }}
              />
            </div>
          </div>
        </Card>
      </LayoutHome>

      {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL FIRMAS <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
      <Modal size={"md"} open={openModalFirma} onClose={handleCloseModalFirma}>
        <Modal.Header>
          <Modal.Title>Firma del Médico</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Panel bordered>
            <SignatureCanvas
              ref={signCanvas}
              canvasProps={{
                style: { width: "100%", minHeight: "376px" },
              }}
            />
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <Button
            icon={<Eraser></Eraser>}
            color="default"
            variant="solid"
            onClick={clear}
          >
            Borrar
          </Button>
          <Button
            icon={<Save size={16}></Save>}
            type="primary"
            onClick={saveSignature}
          >
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
